<div class="company-reports">
  <div class="summary muted">{{ 'CLIENT_REPORT.RECORDS' | translate: {count: totalCount} }}</div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <table mat-table [dataSource]="rows" class="full-width">
    <ng-container matColumnDef="sentAt">
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT_REPORT.SENT_AT' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ (row.sentAt || row.createdAt) | date: 'yyyy-MM-dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="order">
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT_REPORT.ORDER' | translate }}</th>
      <td mat-cell *matCellDef="let row"><a [routerLink]="['/orders/edit', orderNumber(row)]">{{ orderNumber(row) }}</a></td>
    </ng-container>

    <ng-container matColumnDef="recipients">
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT_REPORT.RECIPIENTS' | translate }}</th>
      <td mat-cell *matCellDef="let row" class="small">{{ row.recipients?.join(', ') }}</td>
    </ng-container>

    <ng-container matColumnDef="period">
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT_REPORT.PERIOD' | translate }}</th>
      <td mat-cell *matCellDef="let row" class="small muted">{{ row.dateFrom }} – {{ row.dateTo }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT_REPORT.STATUS' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.status === statuses.Sent" class="status sent">{{ 'CLIENT_REPORT.STATUS_SENT' | translate }}</span>
        <span *ngIf="row.status === statuses.Failed" class="status failed">{{ 'CLIENT_REPORT.STATUS_FAILED' | translate }}</span>
        <span *ngIf="row.status === statuses.Queued" class="status">{{ 'CLIENT_REPORT.STATUS_QUEUED' | translate }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="figures">
      <th mat-header-cell *matHeaderCellDef [matTooltip]="'CLIENT_REPORT.FIGURES_HINT' | translate">
        {{ 'CLIENT_REPORT.FIGURES' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="small muted">
        {{ row.stats?.totalCandidates || 0 }} · {{ row.stats?.hired || 0 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="open">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row"><button mat-button color="primary" (click)="open(row)">{{ 'CLIENT_REPORT.OPEN' | translate }}</button></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>

  <p *ngIf="!loading && !rows.length" class="muted empty">{{ 'CLIENT_REPORT.EMPTY' | translate }}</p>

  <mat-paginator [length]="totalCount" [pageSize]="pageSize" [hidePageSize]="true" (page)="onPage($event)"></mat-paginator>
</div>
